<template>
  <div class="text-center">
    <pie-chart :chart-data="chartData" :options="options" style="height: 200px"></pie-chart>
    <div style="font-size: 0.8em; text-transform: uppercase">Member Type Distribution</div>
  </div>
</template>

<script>
import BarChart from '../../utils/BarChart'
import MembershipDashboardMixin from './MembershipDashboardMixin'
import _ from 'lodash'
import PieChart from '../../utils/PieChart'

export default {
  name: '',
  data: function () {
    return {
      palette: [
        '#741D72',
        '#832181',
        '#932591',
        '#A329A1',
        '#B42DB1'
      ],
      palette2: [
        '#961D00', '#741D72',
        '#B82500', '#832181',
        '#CC2900', '#932591',
        '#E02D00', '#A329A1',
        '#E83100', '#B42DB1'
      ]
    }
  },
  components: {
    PieChart,
    BarChart
  },
  computed: {
    chartData: function () {
      let categoriesMapped = {}
      this.members.forEach((member) => {
        member.categories.forEach((category) => {
          let categoryText = category.text
          if (!(categoryText in categoriesMapped)) {
            categoriesMapped[categoryText] = {
              'text': categoryText,
              'count': 1
            }
          } else {
            categoriesMapped[categoryText].count++
          }
        })
      })
      //  Once mapped, turn into an array.
      let categoriesArrayed = []
      _.forEach(categoriesMapped, function (value, key) {
        categoriesArrayed.push(value)
      })
      //  Sort it.
      categoriesArrayed.sort((x) => x.count)

      let labels = []
      let data = []
      let background = []

      let vm = this
      categoriesArrayed.forEach((categoryMap) => {
        labels.push(categoryMap.text)
        data.push(categoryMap.count)
        background.push(vm.palette[data.length % vm.palette.length])
      })

      return {
        labels: labels,
        datasets: [
          {
            label: 'here',
            data: data,
            backgroundColor: background,
            borderColor: '#243447'
          }
        ]
      }
    },
    options: function () {
      return {
        aspectRatio: 1,
        maintainAspectRatio: false,
        layout: {
          padding: {
            left: 10,
            right: 10,
            top: 0,
            bottom: 0
          }
        },
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              stacked: true,
              gridLines: {
                display: false
              },
              ticks: {
                display: false
              }
            }
          ],
          xAxes: [
            {
              stacked: true,
              gridLines: {
                display: false
              },
              ticks: {
                display: false
              }
            }
          ]
        }
      }
    }
  },
  mixins: [MembershipDashboardMixin]
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/membership/MembershipCategoryChart.vue